<template>
  <a-card :title="$t(`moduleTitles.${$route.meta.title}`)" :bordered="false">
    <a-row>
      <a-col :span="12">
        <a-form-model layout="vertical" ref="ruleForm" :form="form" :rules="rules" :model="form">
          <a-form-model-item
            has-feedback
            :label="$t('form.accountSecure.field.orginPassword.label')+'：'"
            prop="old_password"
          >
            <a-input-password
              v-model="form.old_password"
              :placeholder="$t('form.accountSecure.field.orginPassword.placeholder')"
            />
          </a-form-model-item>
          <a-form-model-item
            has-feedback
            :label="$t('form.accountSecure.field.newPassword.label')+'：'"
            prop="new_password"
          >
            <a-input-password
              v-model="form.new_password"
              :placeholder=" $t('form.accountSecure.field.newPassword.placeholder')"
            />
          </a-form-model-item>

          <a-form-model-item
            has-feedback
            :label="$t('form.accountSecure.field.confirmPassword.label')+'：'"
            prop="confirm_password"
          >
            <a-input-password
              v-model="form.confirm_password"
              :placeholder=" $t('form.accountSecure.field.confirmPassword.placeholder')"
            />
          </a-form-model-item>

          <a-form-model-item>
            <a-button type="primary" @click="handleSubmit">{{$t('actionTitles.confirm')}}</a-button>
          </a-form-model-item>
        </a-form-model>
      </a-col>
      <a-col :span="12"></a-col>
    </a-row>
  </a-card>
</template>

<script>
import { updatePassword } from "@/api/user";
export default {
  components: {},

  data() {
    let validatePass2 = (rule, value, callback) => {
      if (value === "") {
        callback(
          new Error(
            this.$i18n.t("form.accountSecure").field.confirmPassword.message
          )
        );
      } else if (value !== this.form.new_password) {
        callback(
          new Error(
            this.$i18n.t(
              "form.accountSecure"
            ).field.confirmPassword.inconformityMessage
          )
        );
      } else {
        callback();
      }
    };
    return {
      form: {},
      rules: {
        old_password: [
          {
            required: true,
            message: this.$i18n.t("form.accountSecure").field.orginPassword
              .message,
            trigger: "blur",
          },
        ],
        new_password: [
          {
            required: true,
            message: this.$i18n.t("form.accountSecure").field.newPassword
              .message,
            trigger: "blur",
          },
          {
            min: 6,
            message: this.$i18n.t("form.accountSecure").field.newPassword
              .lengthMessage,
            trigger: "blur",
          },
        ],
        confirm_password: [{ validator: validatePass2, trigger: "change" }],
      },
    };
  },
  mounted() {},
  methods: {
    handleSubmit() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          updatePassword(this.form).then((res) => {
            this.$message.success(this.$t('message.modifySuccess'));
            this.$store.dispatch("logout")
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    handleSelectChange() {},
  },
};
</script>

<style scoped>
</style>